export class FiltrosContratos {
  numero: string;
  ano: string;
  idProcedimentoOrigem: string;
  idTipo: number;
  objeto: string;
  valorMin: number;
  valorMax: number;
  situacao: string;

  constructor() {
    this.limpar();
  }

  limpar(): void {
    this.numero = "";
    this.ano = "";
    this.idTipo = 0;
    this.idProcedimentoOrigem = "";
    this.objeto = "";
    this.valorMin = 0;
    this.valorMax = 0;
    this.situacao = "";
  }

  toFormData(): FormData {
    const data = new FormData();
    if (this.ano) data.append("filtroAno", this.ano);
    if (this.numero) data.append("filtroNumero", this.numero);
    if (this.idProcedimentoOrigem) data.append("filtroProcOrigem", this.idProcedimentoOrigem);
    if (this.idTipo > 0)
      data.append("filtroTipo", String(this.idTipo));
    
    if (this.objeto) data.append("filtroObjeto", this.objeto);
    return data;
  }

  toQueryString(): string {
    let retorno = "";
    if (this.ano) retorno += "&filtroAno=" + this.ano;
    if (this.numero) retorno += "&filtroNumero=" + this.numero;
    if (this.idProcedimentoOrigem) retorno += "&filtroProcOrigem=" + this.idProcedimentoOrigem;
    if (this.idTipo > 0)
      retorno += "&filtroTipo=" + String(this.idTipo);
    if (this.objeto) retorno += "&filtroObjeto=" + this.objeto;
    retorno += "&filtroValorMin=" + String(this.valorMin);
    if (this.valorMax > 0)
      retorno += "&filtroValorMax=" + String(this.valorMax);
    if (this.situacao) retorno += "&filtroSituacao=" + this.situacao;

    return retorno;
  }
}
